module.exports = __webpack_public_path__ + "static/media/MINI-TEST-COUNT-4.1a98fa10.png";